import { dispatcher } from 'dispatcher';
import { showConfirmationPopupAction } from 'js/components/common/popups/ConfirmationPopup';

import { acceptBonusMessage } from './server';

export const UPDATE_BONUS_HISTORY_PERIOD = 'BONUS_HISTORY:UPDATE_PERIOD';

export const updateBonusHistoryPeriod = () => ({
    type: UPDATE_BONUS_HISTORY_PERIOD
});

export const showBonusPopupAction = ({ id, layer, title, content, dialogId, acceptBtnText, declineBtnText, dispatch }) => {
    const onAccept = () => acceptBonusMessage({ accept: true, dialogId });
    const onDecline = () => acceptBonusMessage({ accept: false, dialogId });
    const onClose = () => {
        // todo remove dispatcher.dispatch('notification-bonus:updated') after portal implementation COR18-10496
        dispatcher.dispatch('notification-bonus:updated');
        dispatch(updateBonusHistoryPeriod());
    };

    return showConfirmationPopupAction({
        id,
        layer,
        title,
        className: 'bonus-popup',
        content,
        onClose,
        onAccept,
        onDecline,
        acceptBtnText,
        declineBtnText
    });
};
